import { Loader2 } from 'lucide-react';
import { cn } from '@shared/lib/cn';

interface SpinnerProps {
  readonly className?: string;
  readonly label?: string;
}

/**
 * Indeterminate progress indicator. Use for in-flight async actions where the
 * duration is unknown. Inherits color from the surrounding text.
 *
 * Render inside a parent that has a visual label so screen readers announce
 * the operation; this component carries `aria-hidden` because Loader2 is
 * decorative on its own.
 */
export function Spinner({ className, label }: SpinnerProps): React.JSX.Element {
  return (
    <Loader2
      className={cn('animate-spin', className)}
      aria-hidden={label === undefined ? true : undefined}
      aria-label={label}
      role={label === undefined ? undefined : 'status'}
    />
  );
}
